import {CouponInfoSheet} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {CouponSections} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/sections.types';
import React from 'react';
import styled from 'styled-components';
import {MoreCouponsSection} from './Components/MoreCouponsSection';
import {COUPON_WALLET_INFO_ICON_CUSTOM_KEY} from './deprecated/highTierWallet/WalletBodyContentView';

export const CouponWalletContent = (props: {
  sections: CouponSections[];
  setSelectedProduct?: (product: Product | undefined) => void;
  paused?: boolean;
  handleInfoIconClick: (couponInfo?: CouponInfoSheet) => void;
}) => {
  const {sections, setSelectedProduct, paused, handleInfoIconClick} = props;

  if (!sections || sections.length === 0) return null;

  return (
    <>
      <Wrapper data-testid="couponWalletContent">
        {sections.map((section, index) => {
          switch (section.type?.$case) {
            case 'moreCouponsSection':
              return (
                <StyledMoreCouponsSection
                  key={`${section.type.moreCouponsSection.headline}-${index}`}
                  headline={section.type.moreCouponsSection.headline}
                  coupons={section.type.moreCouponsSection.coupons}
                  handleInfoIconClick={handleInfoIconClick}
                  stateManagerCustomKey={COUPON_WALLET_INFO_ICON_CUSTOM_KEY}
                  setSelectedProduct={setSelectedProduct}
                  paused={paused}
                  makeInert={Boolean(paused)}
                />
              );
            default:
              return null;
          }
        })}
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledMoreCouponsSection = styled(MoreCouponsSection)`
  padding-top: 0;
`;
